var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 10.125L12.4072 20.25",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 3.75L12.4072 6.375",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 10.125C13.4428 10.125 14.2822 9.28553 14.2822 8.25C14.2822 7.21447 13.4428 6.375 12.4072 6.375C11.3717 6.375 10.5322 7.21447 10.5322 8.25C10.5322 9.28553 11.3717 10.125 12.4072 10.125Z",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1572 17.625L19.1573 20.25",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1573 3.75L19.1572 13.875",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2822 17.25C20.3177 17.25 21.1572 16.4105 21.1572 15.375C21.1572 14.3395 20.3177 13.5 19.2822 13.5C18.2466 13.5 17.4072 14.3395 17.4072 15.375C17.4072 16.4105 18.2466 17.25 19.2822 17.25Z",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6573 14.625L5.65723 20.25",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65723 3.75L5.6573 10.875",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65729 14.625C6.69282 14.625 7.53229 13.7855 7.53229 12.75C7.53229 11.7145 6.69282 10.875 5.65729 10.875C4.62175 10.875 3.78229 11.7145 3.78229 12.75C3.78229 13.7855 4.62175 14.625 5.65729 14.625Z",
    stroke: "#747A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.c03c9945f7340241f159bf33bb7474a9.svg";
export { ForwardRef as ReactComponent };